export default __webpack_public_path__ + "static/J Venture_logo-aa622c114095fded829131d02170e964.png";